import { HStack, Pressable, View, VStack } from "@gluestack-ui/themed";
import { memo } from "react";

import { Text } from "@repo/core/components/core/Text";

import { ConfirmTokenController } from "./controller";
import { ActionSheet } from "@repo/core/components/layout/Actionsheet";
import { AlertModal } from "@repo/core/components/layout/ModalTemplate/AlertModal";
import { AlertModalVariant } from "@repo/core/components/layout/ModalTemplate/AlertModal/types";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ConfirmTokenFooter } from "@repo/core/screens/PreProposal/screens/ConfirmToken/components/ConfirmTokenFooter";
import { Icon } from "@repo/core/components/core/Icon";
import { InputOTPControlled } from "@repo/core/components/forms/InputOTPControlled";
import Spinner from "@repo/core/components/core/Spinner";

const ConfirmTokenComponent = () => {
  const {
    control,
    cellPhone,
    handleResendCode,
    back,
    alertModalRef,
    actionSheetRef,
    handleMoreInformation,
    isResendingToken,
    alertOptions,
    handleSubmitForm,
    isSubmitting,
    hasPermissionToDispenseToken,
    handleSkipTokenVerification,
    isSkippingToken,
    shouldEnableResend,
    setShouldEnableResend,
    otpInputKey,
    expiresInSeconds
  } = ConfirmTokenController();

  return (
    <>
      <PageScaffold
        title="Token"
        onBackPress={back}
        rightWebLabel="Ajuda"
        onPressRightIcon={handleMoreInformation}
        footerContent={
          <ConfirmTokenFooter
            isSubmitting={isSubmitting}
            handleSubmitForm={handleSubmitForm}
            handleResendCode={handleResendCode}
            isResendingToken={isResendingToken}
            shouldEnableResend={shouldEnableResend}
            setShouldEnableResend={setShouldEnableResend}
            countdownTime={expiresInSeconds}
          />
        }
      >
        <VStack w="$full" h="$full" alignItems="center" justifyContent="center">
          <View mb="$4" alignItems="center" justifyContent="center">
            <Icon name="key" size={40} color="$primary600" />
          </View>
          <Text mb="$6" fontSize="$lg" fontWeight={600} color="$textLight900">
            Token de Verificação!
          </Text>
          <View
            maxWidth={230}
            mb="$10"
            alignItems="center"
            justifyContent="center"
          >
            <Text
              fontSize="$sm"
              fontWeight={400}
              color="$textLight900"
              textAlign="center"
            >
              Digite o código enviado, via SMS, para o celular{" "}
              <Text fontSize="$sm" fontWeight={600} color="$textLight900">
                {cellPhone}
              </Text>
            </Text>
          </View>

          <View w="$full" alignItems="center" justifyContent="center" gap="$6">
            <InputOTPControlled
              key={otpInputKey}
              control={control}
              name="code"
            />
            {hasPermissionToDispenseToken && (
              <Pressable
                onPress={handleSkipTokenVerification}
                disabled={isSkippingToken}
                accessibilityState={{
                  busy: isSkippingToken,
                  disabled: isSkippingToken
                }}
                alignItems="center"
                justifyContent="center"
              >
                <HStack alignItems="center" gap="$1">
                  <Text
                    fontSize="$sm"
                    mb="$0.5"
                    fontWeight={400}
                    color="$textLight900"
                  >
                    Pular verificação
                  </Text>
                  {isSkippingToken ? (
                    <Spinner size="small" color="$textLight900" />
                  ) : (
                    <Icon
                      name="chevron-right"
                      size={12}
                      color="$textLight900"
                    />
                  )}
                </HStack>
              </Pressable>
            )}
          </View>
        </VStack>
      </PageScaffold>
      <ActionSheet ref={actionSheetRef}>
        <VStack w="$full" p="$2" mb="$2">
          <VStack mb="$4" px="$3">
            <Text fontSize="$md" fontWeight={500} color="$textLight600">
              Mais informações
            </Text>
          </VStack>
          <VStack mb="$4" px="$3" minHeight="$32" />
        </VStack>
      </ActionSheet>
      <AlertModal
        ref={alertModalRef}
        title="Token não validado"
        text="Houve um erro ao validar o token. Por favor, tente novamente ou entre em contato com nosso suporte."
        variant={AlertModalVariant.error}
        options={alertOptions}
      />
    </>
  );
};

export const ConfirmToken = memo(ConfirmTokenComponent);
